// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1l5PC","range":"MonthRangeSwitch_range__96AhW","disabled":"MonthRangeSwitch_disabled__2HwWR"};